import React from "react";
import "./AdDetailsInfo.css";

const AdDetailsInfo = ({ price, created_at, view_count_24, view_count_total }) => {
    // Pripravimo formatiran datum za lažjo berljivost
    const formattedDate = new Date(created_at).toLocaleDateString('sl-SI', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    return (
        <div className="main_info d-sm-flex justify-content-between align-items-end">
            <div className="item_price">
                <span className="price">{price}€</span>
                {/* <span className="price_quality">Odlična cena</span> */}
            </div>
            <div className="item_date_views">
                <ul className="meta">
                    <li>
                        <p>Objavljeno: {formattedDate}</p>
                    </li>
                    {/* Popravljen del za prikaz ogledov */}
                    <li className="views-meta">
                        <i className="fa fa-eye"></i>
                        <div className="view_counts">
                            <span><strong>{view_count_24}</strong> ogledov (24h)</span>
                            <span><strong>{view_count_total}</strong> vseh ogledov</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default AdDetailsInfo;